export default __webpack_public_path__ + "static/media/26_jpeg.4f1b58da.jpg";